/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import { getPages } from '../table/TablePaginationHelpers';

export function PaginationLinks ({ paginationProps }) {
    const { totalSize, sizePerPage, page } = paginationProps;
    const pages = getPages(page, totalSize, sizePerPage);
    const hasPrevius = page > 1;
    const hasNext = totalSize === sizePerPage;

    const handleFirstPage = ({ onPageChange }) => onPageChange(1);

    const handlePrevPage = ({ page, onPageChange }) => onPageChange(page - 1);

    const handleNextPage = ({ page, onPageChange }) => {
        if (hasNext) {
            onPageChange(page + 1);
        }
    };

    const handleSelectedPage = ({ onPageChange }, pageNum) => onPageChange(pageNum);

    return (
        <>
            <div className='d-flex flex-wrap py-2 mr-3'>
                <a
                    onClick={() => handleFirstPage(paginationProps)}
                    className={`btn btn-icon btn-sm btn-light btn-hover-primary mr-2 my-1 ${!hasPrevius ? 'disabled' : ''}`}
                    disabled={!hasPrevius}
                >
                    <i className='ki ki-bold-double-arrow-back icon-xs' />
                </a>
                <a
                    onClick={() => handlePrevPage(paginationProps)}
                    className={`btn btn-icon btn-sm btn-light btn-hover-primary mr-2 my-1 ${!hasPrevius ? 'disabled' : ''}`}
                    disabled={!hasPrevius}
                >
                    <i className='ki ki-bold-arrow-back icon-xs' />
                </a>

                {page > 1 && (
                    <a className='btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1 disabled'>...</a>
                )}
                {pages.map((p) => (
                    <a
                        key={p}
                        onClick={() => handleSelectedPage(paginationProps, p)}
                        className={`btn btn-icon btn-sm border-0 btn-light ${page === p ? ' btn-hover active' : ''} mr-2 my-1 pagLink-btn`}
                    >
                        {p}
                    </a>
                ))}
                {hasNext && (
                    <a className='btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1 disabled'>...</a>
                )}
                <a
                    onClick={() => handleNextPage(paginationProps)}
                    className={`btn btn-icon btn-sm btn-light btn-hover-primary mr-2 my-1 ${!hasNext ? 'disabled' : ''}`}
                    disabled={!hasNext}
                >
                    <i className='ki ki-bold-arrow-next icon-xs'/>
                </a>
            </div>
        </>
    );
}
